import NavBar from "../components/navbar";
import Card from "../components/card";
import Footer from "../components/footer";
import { useNavigate } from "react-router-dom";

function SelfStudy() {
    let navigate = useNavigate();
    return (
        <div className="flex flex-col h-screen justify-between">
            <NavBar />
            <div className="text-3xl w-64 md:w-full flex flex-col md:flex-row justify-center self-center">
                <Card name="python_self_study_link" title="Learn Python" url="https://drive.google.com/file/d/1oLg8PiiNwOrNm51EaPPqdUhIz7slpJ2B/view" image={require("../images/python.jpeg")} text="Python Programming Language"/>
                <Card name="ui_path_self_study_link" title="Learn Ui Path" url="https://docs.uipath.com/studio/docs/tutorials" image={require("../images/UiPath.png")} text="Robotic Process Automation"/>
                <Card name="flutter_self_study_link" title="Learn Flutter" url="https://www.youtube.com/playlist?list=PL4cUxeGkcC9jLYyp2Aoh6hcWuxFDX6PBJ" image={require("../images/flutter.png")} text="Mobile Application Development"/>
                <Card name="react_self_study_link" title="Learn React" url="https://www.youtube.com/playlist?list=PL4cUxeGkcC9gZD-Tvwfod2gaISzfRiP9d" image={require("../images/react.png")} text="Web Application Development"/>
                <Card name="uiux_self_study_link" title="Learn UI/UX" url="https://www.coursera.org/professional-certificates/google-ux-design" image={require("../images/uiux.jpeg")} text="User Interface/User eXperience"/>
            </div>
            <div className="justify-center self-center">Prefer a class environment? <span className="underline cursor-pointer" onClick={() => {navigate("/")}}>Click here</span></div>
            <Footer />
        </div>
    );
}

export default SelfStudy;
